import React, { useState, useContext } from "react";
import { Button, Form, Container, Row, Col } from "react-bootstrap";
import { CartContext } from "../../../context/CartContext";
import axios from "axios";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

import { useDispatch } from "react-redux";
import {
  setAddressOrder,
  setNameOrder,
  setPhoneOrder,
  setRegionOrder,
  setCityOrder,
  setEmailBuyer,
} from "../../../features/wompi/WompiSlice.jsx";

import { initMercadoPago, Wallet } from "@mercadopago/sdk-react";

export default function Checkout2() {
  initMercadoPago(process.env.REACT_APP_PUBLIC_KEY_MELI, {
    locale: "es-CO",
  });

  const { carrito, precioTotal, vaciarCarrito } = useContext(CartContext);

  const [name, setName] = useState("");
  const [documentType, setDocumentType] = useState("CC");
  const [identification_document, setIdentification_document] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [phone, setPhone] = useState("");

  const [departamento, setDepartamento] = useState("Bogotá D.C.");
  const [ciudad_o_municipio, setCiudad_o_municipio] = useState("");
  const [barrio, setBarrio] = useState("");
  const [direccion, setDireccion] = useState("");
  const [referencias_entrega, setReferencias_entrega] = useState("");

  const [ordenCompleta, setOrdenCompleta] = useState(false);
  const [referenciaDePago, setReferenciaDePago] = useState("");
  const [preferenceId, setPreferenceId] = useState(null);
  const [amount, setAmount] = useState("");

  // ✅ NUEVO: bloqueo UI
  const [isLoading, setIsLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Procesando tu orden...");

  const apiURL = process.env.REACT_APP_API_URL;
  const dispatch = useDispatch();

  const createPreference = async () => {
    try {
      setIsLoading(true);
      setLoadingText("Abriendo Mercado Pago...");

      const response = await axios.post(`${apiURL}/mercadoPago`, {
        title: referenciaDePago,
        quantity: 1,
        amount: amount,
      });

      const { id } = response.data;
      setPreferenceId(id);
      setOrdenCompleta(false);
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No pudimos abrir Mercado Pago. Intenta de nuevo.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const resetForm = () => {
    setName("");
    setIdentification_document("");
    setEmail("");
    setPhone("");
    setMessage("");
    setDepartamento("Bogotá D.C.");
    setCiudad_o_municipio("");
    setBarrio("");
    setDireccion("");
    setReferencias_entrega("");
  };

  const handleSubmit = async () => {
    if (isLoading) return;

    try {
      setIsLoading(true);
      setLoadingText("Generando tu orden y enviando el correo...");

      const TicketForm = {
        name: name,
        identification_document: `${documentType}: ${identification_document}`,
        purchaser: email,
        phone: phone,
        message: message,
        departamento: departamento,
        ciudad_o_municipio: ciudad_o_municipio,
        barrio: barrio,
        direccion: direccion,
        referencias_entrega: referencias_entrega,
        statusPay: "PENDING",
        cart: carrito,
        amount: precioTotal(),
      };

      // (opcional) aviso rápido, pero NO bloquea el flujo
      Swal.fire({
        position: "center",
        icon: "info",
        title: "Alistando tu orden...",
        text: "Por favor no cierres ni recargues esta página.",
        showConfirmButton: false,
        timer: 1200,
      });

      const res = await axios.post(`${apiURL}/api/purchase/addticket`, TicketForm);

      // ✅ SOLO AQUÍ, cuando ya respondió el backend
      setReferenciaDePago(res.data.payload);
      setAmount(res.data.amount);
      setOrdenCompleta(true);

      // ✅ Ahora sí puedes limpiar (ya existe orden)
      resetForm();
      vaciarCarrito();

      Swal.fire({
        position: "center",
        icon: "success",
        title: "¡Orden lista!",
        text: "Ahora puedes ir a pagar con Mercado Pago.",
        showConfirmButton: false,
        timer: 1300,
      });
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "No se pudo crear la orden",
        text: "Intenta de nuevo. (No se realizó la compra)",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {/* ✅ Overlay bloqueante */}
      {isLoading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20,
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 12,
              padding: 18,
              width: "min(420px, 92vw)",
              textAlign: "center",
              boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
            }}
          >
            <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 10 }}>
              {loadingText}
            </div>
            <div style={{ fontSize: 13, color: "#555" }}>
              No cierres ni recargues la página.
            </div>
            <div style={{ marginTop: 14 }}>
              <div
                style={{
                  width: 38,
                  height: 38,
                  borderRadius: "50%",
                  border: "4px solid #ddd",
                  borderTop: "4px solid #333",
                  margin: "0 auto",
                  animation: "spin 0.9s linear infinite",
                }}
              />
            </div>
          </div>

          <style>
            {`@keyframes spin { from { transform: rotate(0deg);} to {transform: rotate(360deg);} }`}
          </style>
        </div>
      )}

      <Button variant="danger" style={{ marginTop: "10px" }} disabled={isLoading}>
        <Link className="link" to="/">
          &lt; Inicio
        </Link>
      </Button>
      <br />

      <Container style={{ overflow: "auto" }}>
        <Row className="justify-content-center">
          <Col md={8}>
            <h5>Orden</h5>

            {preferenceId && (
              <Wallet
                initialization={{ preferenceId: preferenceId }}
                customization={{ texts: { valueProp: "smart_option" } }}
              />
            )}

            {ordenCompleta && (
              <Button
                variant="success"
                style={{ margin: "10px" }}
                disabled={isLoading}
                onClick={createPreference}
              >
                Ir a MERCADOPAGO
              </Button>
            )}

            {!ordenCompleta && !preferenceId && (
              <Form>
                <Form.Group controlId="name">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Name"
                    value={name}
                    disabled={isLoading}
                    onChange={(e) => {
                      setName(e.target.value);
                      dispatch(setNameOrder(e.target.value));
                    }}
                  />
                </Form.Group>

                <Row className="align-items-end">
                  <Col md={3}>
                    <Form.Group controlId="document_type">
                      <Form.Label>Tipo de Documento</Form.Label>
                      <Form.Select
                        value={documentType}
                        disabled={isLoading}
                        onChange={(e) => setDocumentType(e.target.value)}
                      >
                        <option value="CC">CC</option>
                        <option value="TI">TI</option>
                        <option value="TE">TE</option>
                        <option value="CE">CE</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="identification_document">
                      <Form.Label>Documento</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Documento"
                        value={identification_document}
                        disabled={isLoading}
                        onChange={(e) => setIdentification_document(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group controlId="email">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Email"
                    value={email}
                    disabled={isLoading}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      dispatch(setEmailBuyer(e.target.value));
                    }}
                  />
                </Form.Group>

                <Form.Group controlId="phone">
                  <Form.Label>Phone</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Phone"
                    value={phone}
                    disabled={isLoading}
                    onChange={(e) => {
                      setPhone(e.target.value);
                      dispatch(setPhoneOrder(e.target.value));
                    }}
                  />
                </Form.Group>

                <Form.Group controlId="message">
                  <Form.Label>Sugerencias</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Message"
                    value={message}
                    disabled={isLoading}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </Form.Group>

                <Form.Group controlId="departamento">
                  <Form.Label>Departamento</Form.Label>
                  <select
                    value={departamento}
                    disabled={isLoading}
                    onChange={(e) => {
                      setDepartamento(e.target.value);
                      dispatch(setRegionOrder(e.target.value));
                    }}
                  >
                    <option value="Bogotá D.C.">Bogotá D.C.</option>
                    <option value="Antioquía">Antioquía</option>
                    <option value="Valle del Cauca">Valle del Cauca</option>
                    {/* deja tus demás opciones */}
                  </select>
                </Form.Group>

                <Form.Group controlId="ciudad_o_municipio">
                  <Form.Label>Ciudad o Municipio</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Ciudad o Municipio"
                    value={ciudad_o_municipio}
                    disabled={isLoading}
                    onChange={(e) => {
                      setCiudad_o_municipio(e.target.value);
                      dispatch(setCityOrder(e.target.value));
                    }}
                  />
                </Form.Group>

                <Form.Group controlId="barrio">
                  <Form.Label>Barrio</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Barrio"
                    value={barrio}
                    disabled={isLoading}
                    onChange={(e) => setBarrio(e.target.value)}
                  />
                </Form.Group>

                <Form.Group controlId="direccion">
                  <Form.Label>Direccion</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Direccion"
                    value={direccion}
                    disabled={isLoading}
                    onChange={(e) => {
                      setDireccion(e.target.value);
                      dispatch(setAddressOrder(e.target.value));
                    }}
                  />
                </Form.Group>

                <Form.Group controlId="referencias_entrega">
                  <Form.Label>Referencias del lugar de entrega</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Referencias"
                    value={referencias_entrega}
                    disabled={isLoading}
                    onChange={(e) => setReferencias_entrega(e.target.value)}
                  />
                </Form.Group>

                <Button
                  variant="success"
                  style={{ margin: "10px" }}
                  disabled={isLoading}
                  onClick={handleSubmit}
                >
                  Pagar con MERCADOPAGO
                </Button>

                <Button variant="danger" style={{ margin: "10px" }} disabled={isLoading}>
                  <Link className="Menu" to="/">
                    Cancelar
                  </Link>
                </Button>
              </Form>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
}
